// import { observer } from 'mobx-react-lite';
// import React from 'react';
// import { FormattedMessage, useIntl } from 'react-intl';

// import useContentPage from '../hooks/useContentPage';

// import ContentPageWrapper from '../components/ContentPageWrapper';
// import Title from '../components/Title';
// import Layout from '../components/Layout';
// import SEO from '../components/SEO';

// const AboutPage = ({ uri }) => {
//   const intl = useIntl();
//   const { markup } = useContentPage({ page: 'about_us' });

//   return (
//     <Layout alwaysRaisedHeader uri={uri}>
//       <SEO
//         title={intl.formatMessage({
//           id: 'meta.title.about',
//           defaultMessage: 'About Us'
//         })}
//         description={intl.formatMessage({
//           id: 'meta.description.about',
//           defaultMessage:
//             'Immerse yourself in the world of STK Workshop models. Choose your favourite from our exciting range, including Build The Millennium Falcon and Build Your Own R2-D2. Options for every budget.'
//         })}
//       />
//       <ContentPageWrapper>
//         <Title>
//           <FormattedMessage defaultMessage="About Us" />
//         </Title>
//         <div dangerouslySetInnerHTML={{ __html: markup }} />
//       </ContentPageWrapper>
//     </Layout>
//   );
// };

// export default observer(AboutPage);

import React from 'react';
import Redirect from '../components/Redirect';

const IndexPage = () => {
  return <Redirect to="https://www.stk-workshop.com/" includeQuery />;
  // return <Redirect to="/r2d2" includeQuery />;
};

export default IndexPage;
